
<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6">

                <div class="col-6 col- mt-4 mb-4 gifted-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                            </div>
                        </div>
                        <div class="card card-title text-center">
                            <h3>
                                Gifted Resend Voucher Tool
                            </h3>

                        </div>
                        <div class="row p-3">
                            <div class="col-md-12">
                                <div class="card mb-2">
                                    <div class="card-body text-center">
                                        <h4 class="font-italic">Please enter Order ID or Lazada ID</h4>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <form id="resendForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <input type="text" class="form-control" id="order_number" name="order_number" placeholder="Your Order ID here...." />
                                                </div>
                                            </div>


                                            <input type="hidden" name="_token" id="token">
                                        </form>

                                        <div class="form-row">
                                            <div class="form-group col-md-12 text-center">
                                                <button type="button" @click="resendVoucher()" class="btn btn-success btn-lg" id="btn_submit">Submit</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a> or email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import axios from 'axios'

    export default {
        props: [],
        data(){
            return {
                voucher_code: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {

        },
        methods: {
            resendVoucher: () => {
                let order_number = $('#order_number').val();
                if(order_number)
                {
                    $.ajax({
                        url: `/api/resend_voucher/${order_number}`,
                        success: (result) => {
                             Swal.fire({
                                icon: 'success',
                                title: 'Voucher successfully resent!'
                            })

                            $('#order_number').val('');
                        },
                        beforeSend: () => {
                            Swal.fire({
                                title: 'Resending...',
                                html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                showConfirmButton: false,
                                allowEscapeKey : false,
                                allowOutsideClick: false,
                            });
                        }
                    });
                }
                else{
                     Swal.fire({
                        icon: 'error',
                        title: 'Order ID is required'
                    })
                }

            },
        }
    }



</script>
